import React from "react";
import { useTranslation } from "react-i18next";
import {
    ActionButton,
    Filter,
    Grid,
    useFilterContext,
    useResourceApi,
} from "@programari-limit/base-react";
import { Box, Icon, IconButton, Tooltip } from "@mui/material";
import MuiGrid from "@mui/material/Grid";
import GridFilterField from "components/GridFilterField";
import { SpringFilterQueryBuilder } from "utils/spring-filter-query-builder";
import {
    columnesEmbarcacio,
    columnesZones,
} from "sharedAdvancedSearch/advancedSearchColumns";
import { IconButtonButtonComponent } from "components/ActionReportButtonComponents";
import GridFormField from "components/GridFormField";

const ExportarPuntsForm = () => {
    return (
        <MuiGrid container spacing={2} sx={{ mt: 1 }}>
            <GridFormField name="diaInici" lg={6} />
            <GridFormField name="diaFi" lg={6} />
            <GridFormField
                name="embarcacio"
                lg={12}
                advancedSearchColumns={columnesEmbarcacio}
            />
            <GridFormField name="recurs" lg={12} />
        </MuiGrid>
    );
};

const FilterContent = (props) => {
    const { filterApiRef } = props;
    const { t } = useTranslation();
    const { data } = useFilterContext();

    return (
        <MuiGrid container spacing={2}>
            <GridFilterField
                name="rutaData"
                xs={12}
                sm={4}
                md={4}
                lg={2.5}
                xl={2}
            />
            <GridFilterField
                name="recurs"
                xs={10}
                sm={6}
                md={6}
                lg={4}
                xl={3}
            />
            <MuiGrid xs={0.5} sm={0.5} md={0.5} lg={5} xl={6.5} />
            <MuiGrid item lg={0.5}>
                <Tooltip title={t("comu.resetFiltre")}>
                    <IconButton
                        onClick={() => filterApiRef?.current?.doReset()}
                    >
                        <Icon>filter_alt_off</Icon>
                    </IconButton>
                </Tooltip>
            </MuiGrid>
        </MuiGrid>
    );
};

const RutesFilter = (props) => {
    const { onSpringFilterChange, onFilterInitialized } = props;
    const filterApiRef = React.useRef();

    return (
        <Box sx={{ mb: 2 }}>
            <Filter
                name={"RTP_FILTER"}
                resourceName={"rutaPunt"}
                // persistentState
                springFilterBuilder={(data) => springFilterBuilder(data)}
                onSpringFilterChange={onSpringFilterChange}
                onFilterInitialized={onFilterInitialized}
                size="small"
                apiRef={filterApiRef}
                initialOnChangeRequest
            >
                <FilterContent filterApiRef={filterApiRef} />
            </Filter>
        </Box>
    );
};

const springFilterBuilder = (data) => {
    const { and, equal } = SpringFilterQueryBuilder;

    const filter = and(
        equal("ruta.recurs.id", data?.recurs?.id),
        // equal("ruta.id", data?.ruta?.id),
        equal("rutaData", data?.rutaData)
    ).toString();

    return filter;
};

const springFilterBuilderExport = (data) => {
    const { and, equal, ge, le } = SpringFilterQueryBuilder;

    const filter = and(
        ge("rutaData", data?.diaInici?.substring(0, 19)),
        le("rutaData", data?.diaFi?.substring(0, 19)),
        equal("ruta.embarcacio.id", data?.embarcacio?.id),
        equal("ruta.recurs.id", data?.recurs?.id)
    ).toString();

    return filter;
};

const PuntsRuta = () => {
    const [fixedFilter, setFixedFilter] = React.useState();
    const [filterInitialized, setFilterInitialized] = React.useState(false);
    const { t } = useTranslation();
    const { apiInitialized, execDownload: apiExecDownload } =
        useResourceApi("rutaPunt");

    const exportData = (exportFixedFilter) => ({
        page: "UNPAGED",
        perspective: ["excel"],
        type: "XLSX",
        filter: exportFixedFilter,
        field: [
            "rutaData",
            "nomEmbarcacio",
            "nomRecurs",
            "port",
            "hora",
            "pugen",
            "baixen",
            "total",
            "nous",
            "totalNous",
            "incidencies",
            "observacions",
        ],
    });

    const download = (filter) => {
        apiExecDownload("export", {
            data: exportData(springFilterBuilderExport(filter)),
            // callbacks: exportCallbacks,
        });
    };
    const columns = [
        {
            name: "zona",
            flex: 1,
            formFieldProps: {
                advancedSearchColumns: columnesZones,
                advancedSearchMaxWidth: "sm",
            },
        },
        {
            name: "hora",
            flex: 0.5,
        },
        {
            name: "pugen",
            flex: 0.5,
        },
        {
            name: "baixen",
            flex: 0.5,
        },
        {
            name: "total",
            flex: 0.5,
        },
        {
            name: "nous",
            flex: 0.5,
        },
        {
            name: "totalNous",
            flex: 0.5,
        },
        {
            name: "incidencies",
            flex: 0.5,
        },
        {
            name: "observacions",
            flex: 1.5,
        },
    ];

    return (
        <Grid
            title={t("rutes.tabs.punt.title")}
            resourceName="rutaPunt"
            columns={columns}
            findDisabled={!filterInitialized}
            fixedFilter={fixedFilter}
            readOnly
            // paginable={false}
            toolbarAdditionalActions={[
                {
                    position: 2,
                    component: (
                        <ActionButton
                            resourceName="rutaPunt"
                            code="RP_EXPORTAR_PUNTS"
                            detached
                            variant="contained"
                            formDialogSize="sm"
                            buttonComponent={IconButtonButtonComponent}
                            icon="file_present"
                            formChildren={<ExportarPuntsForm />}
                            onSuccess={(params) => {
                                download(params);
                            }}
                        />
                    ),
                },
            ]}
            toolbarAdditionalRow={
                <RutesFilter
                    onSpringFilterChange={setFixedFilter}
                    onFilterInitialized={() => setFilterInitialized(true)}
                />
            }
            density="compact"
            defaultSortModel={[
                {
                    field: "hora",
                    sort: "asc",
                },
            ]}
        />
    );
};

export default PuntsRuta;
